import {APIStatus} from '@web/core/constants'
import makeSlice from '@web/slices/common/sliceMaker'

import {initPaymentMethodManagement} from '../../actions'

const slice = makeSlice({
    extraReducers(builder) {
        builder
            .addCase(initPaymentMethodManagement.pending, (state) => {
                state.scene = APIStatus.FETCHING
            })
            .addCase(initPaymentMethodManagement.fulfilled, (state, {payload}) => {
                state.scene = APIStatus.RESOLVED
                state.payNecessary = false
                state.entry = payload.entry
            })
            .addCase(initPaymentMethodManagement.rejected, (state) => {
                state.scene = APIStatus.REJECTED
            })
    },
})

export default slice.reducer
